export const LotStatuses = {
  CREATED: "Created",
  ACTIVE: "Active",
  IN_PROGRESS: "In Progress",
  CLOSED: "Closed",
};
